/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Buildhover_Unknownbuild2Inputs */

const id_home_buildhover_unknownbuild2 = /** @type {(inputs: Home_Buildhover_Unknownbuild2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build Tidak Diketahui`)
};

const ms_home_buildhover_unknownbuild2 = /** @type {(inputs: Home_Buildhover_Unknownbuild2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binaan Tidak Diketahui`)
};

const da_home_buildhover_unknownbuild2 = /** @type {(inputs: Home_Buildhover_Unknownbuild2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukendt Build`)
};

const de_home_buildhover_unknownbuild2 = /** @type {(inputs: Home_Buildhover_Unknownbuild2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbekannter Build`)
};

const en_us2_home_buildhover_unknownbuild2 = /** @type {(inputs: Home_Buildhover_Unknownbuild2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown Build`)
};

const es_es2_home_buildhover_unknownbuild2 = /** @type {(inputs: Home_Buildhover_Unknownbuild2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilación desconocida`)
};

const es_mx2_home_buildhover_unknownbuild2 = /** @type {(inputs: Home_Buildhover_Unknownbuild2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilación desconocida`)
};

const fil_home_buildhover_unknownbuild2 = /** @type {(inputs: Home_Buildhover_Unknownbuild2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi Kilalang Build`)
};

const fr_home_buildhover_unknownbuild2 = /** @type {(inputs: Home_Buildhover_Unknownbuild2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilation inconnue`)
};

const it_home_buildhover_unknownbuild2 = /** @type {(inputs: Home_Buildhover_Unknownbuild2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build sconosciuta`)
};

const hu_home_buildhover_unknownbuild2 = /** @type {(inputs: Home_Buildhover_Unknownbuild2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ismeretlen build`)
};

const nl_home_buildhover_unknownbuild2 = /** @type {(inputs: Home_Buildhover_Unknownbuild2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onbekende build`)
};

const no_home_buildhover_unknownbuild2 = /** @type {(inputs: Home_Buildhover_Unknownbuild2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukjent build`)
};

const pl_home_buildhover_unknownbuild2 = /** @type {(inputs: Home_Buildhover_Unknownbuild2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieznana kompilacja`)
};

const pt_br2_home_buildhover_unknownbuild2 = /** @type {(inputs: Home_Buildhover_Unknownbuild2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build desconhecida`)
};

const pt_home_buildhover_unknownbuild2 = /** @type {(inputs: Home_Buildhover_Unknownbuild2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilação desconhecida`)
};

const ro_home_buildhover_unknownbuild2 = /** @type {(inputs: Home_Buildhover_Unknownbuild2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilare necunoscută`)
};

const fi_home_buildhover_unknownbuild2 = /** @type {(inputs: Home_Buildhover_Unknownbuild2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuntematon koontiversio`)
};

const sv_home_buildhover_unknownbuild2 = /** @type {(inputs: Home_Buildhover_Unknownbuild2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Okänt bygge`)
};

const vi_home_buildhover_unknownbuild2 = /** @type {(inputs: Home_Buildhover_Unknownbuild2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bản dựng không xác định`)
};

const tr_home_buildhover_unknownbuild2 = /** @type {(inputs: Home_Buildhover_Unknownbuild2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilinmeyen Yapı`)
};

const cs_home_buildhover_unknownbuild2 = /** @type {(inputs: Home_Buildhover_Unknownbuild2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neznámé sestavení`)
};

const bg_home_buildhover_unknownbuild2 = /** @type {(inputs: Home_Buildhover_Unknownbuild2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Непозната компилация`)
};

const ru_home_buildhover_unknownbuild2 = /** @type {(inputs: Home_Buildhover_Unknownbuild2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неизвестная сборка`)
};

const uk_home_buildhover_unknownbuild2 = /** @type {(inputs: Home_Buildhover_Unknownbuild2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Невідома збірка`)
};

const ar_home_buildhover_unknownbuild2 = /** @type {(inputs: Home_Buildhover_Unknownbuild2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بنية غير معروفة`)
};

const hi_home_buildhover_unknownbuild2 = /** @type {(inputs: Home_Buildhover_Unknownbuild2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अज्ञात बिल्ड`)
};

const th_home_buildhover_unknownbuild2 = /** @type {(inputs: Home_Buildhover_Unknownbuild2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บิลด์ที่ไม่รู้จัก`)
};

const ja_home_buildhover_unknownbuild2 = /** @type {(inputs: Home_Buildhover_Unknownbuild2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不明なビルド`)
};

const zh_cn2_home_buildhover_unknownbuild2 = /** @type {(inputs: Home_Buildhover_Unknownbuild2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未知构建版本`)
};

const zh_hant1_home_buildhover_unknownbuild2 = /** @type {(inputs: Home_Buildhover_Unknownbuild2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未知建置版本`)
};

const ko_home_buildhover_unknownbuild2 = /** @type {(inputs: Home_Buildhover_Unknownbuild2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`알 수 없는 빌드`)
};

/**
* | output |
* | --- |
* | "Unknown Build" |
*
* @param {Home_Buildhover_Unknownbuild2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_buildhover_unknownbuild2 = /** @type {((inputs?: Home_Buildhover_Unknownbuild2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Buildhover_Unknownbuild2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_buildhover_unknownbuild2(inputs)
	if (locale === "ms") return ms_home_buildhover_unknownbuild2(inputs)
	if (locale === "da") return da_home_buildhover_unknownbuild2(inputs)
	if (locale === "de") return de_home_buildhover_unknownbuild2(inputs)
	if (locale === "en-US") return en_us2_home_buildhover_unknownbuild2(inputs)
	if (locale === "es-ES") return es_es2_home_buildhover_unknownbuild2(inputs)
	if (locale === "es-MX") return es_mx2_home_buildhover_unknownbuild2(inputs)
	if (locale === "fil") return fil_home_buildhover_unknownbuild2(inputs)
	if (locale === "fr") return fr_home_buildhover_unknownbuild2(inputs)
	if (locale === "it") return it_home_buildhover_unknownbuild2(inputs)
	if (locale === "hu") return hu_home_buildhover_unknownbuild2(inputs)
	if (locale === "nl") return nl_home_buildhover_unknownbuild2(inputs)
	if (locale === "no") return no_home_buildhover_unknownbuild2(inputs)
	if (locale === "pl") return pl_home_buildhover_unknownbuild2(inputs)
	if (locale === "pt-BR") return pt_br2_home_buildhover_unknownbuild2(inputs)
	if (locale === "pt") return pt_home_buildhover_unknownbuild2(inputs)
	if (locale === "ro") return ro_home_buildhover_unknownbuild2(inputs)
	if (locale === "fi") return fi_home_buildhover_unknownbuild2(inputs)
	if (locale === "sv") return sv_home_buildhover_unknownbuild2(inputs)
	if (locale === "vi") return vi_home_buildhover_unknownbuild2(inputs)
	if (locale === "tr") return tr_home_buildhover_unknownbuild2(inputs)
	if (locale === "cs") return cs_home_buildhover_unknownbuild2(inputs)
	if (locale === "bg") return bg_home_buildhover_unknownbuild2(inputs)
	if (locale === "ru") return ru_home_buildhover_unknownbuild2(inputs)
	if (locale === "uk") return uk_home_buildhover_unknownbuild2(inputs)
	if (locale === "ar") return ar_home_buildhover_unknownbuild2(inputs)
	if (locale === "hi") return hi_home_buildhover_unknownbuild2(inputs)
	if (locale === "th") return th_home_buildhover_unknownbuild2(inputs)
	if (locale === "ja") return ja_home_buildhover_unknownbuild2(inputs)
	if (locale === "zh-CN") return zh_cn2_home_buildhover_unknownbuild2(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_buildhover_unknownbuild2(inputs)
	return ko_home_buildhover_unknownbuild2(inputs)
});
export { home_buildhover_unknownbuild2 as "home.buildHover.unknownBuild" }